// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf } from "@altostra/type-validations";
import { boolean, number, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

/** Validator for a single ruleset object */
const isRuleset = objectOf({
  name: string,
  rules: arrayOf(string),
});

export const isGenerativeAiAgentIdResult = objectOf({
  result: objectOf({
    id: string,
    name: string,
    description: string,
    marked_as_deleted: boolean,
    model: string,
    provider: number,
    /** Campaign QA agents may have no prompt (use rulesets instead) */
    prompt: anyOf(string, nullOrUndefined),
    braze_tool_ids: arrayOf(number),
    use_brand_guidelines: boolean,
    brand_guideline_id: anyOf(string, nullOrUndefined),
    created_at: number,
    updated_at: number,
    created_by: string,
    response_schema_json: anyOf(string, nullOrUndefined),
    /** Campaign QA agents use rulesets instead of prompt */
    rulesets: anyOf(arrayOf(isRuleset), nullOrUndefined),
    /** Optional territory scoping for Campaign QA agents */
    territory_ids: arrayOf(string),
  }),
});
